window.is_ie = /MSIE|Trident/i.test(navigator.userAgent);
window.is_iphone = /iPhone|iPod/i.test(navigator.userAgent);
window.is_touch_device = 'ontouchstart' in document.documentElement;
California.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

California.Sections.prototype = _.assignIn({}, California.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

California.Currency = (function() {
  var moneyFormat = '$';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();
California.Hero = (function() {

  var $hero, 
      $slides,
      $hero_slides,
      $hero_slide,
      $hero_text,
      $window;

  function Hero(container) {
    $hero = $(container);
    $slides = $('.slides', $hero);
    $hero_slide = $('.slide', $hero);
    $hero_text = $('.content .container', $hero);
    $window = $(window);

    if ($hero_slide.length > 1) {
      $slides.slick({
        arrows: false,
        dots: true,
        pauseOnHover: false,
        fade: $slides.data('use-fade'),
        autoplay: $slides.data('autoplay'),
        autoplaySpeed: $slides.data('speed'),
        easing: 'easeInOutQuad',
        speed: 1200
      });
    }

    // parallax
    if ($hero.hasClass('with-parallax')) {
      $window.on('scroll.parallax', function(e){
        var scrolled = $window.scrollTop();
        $hero_slide.css('transform', 'translate3d(0, ' + scrolled / 4.5 + 'px, 0)');
        $hero_text.css('transform', 'translate3d(0, ' + scrolled / 20 + 'px, 0)');
      }).trigger('scroll.parallax');
    } else {
      $window.off('scroll.parallax');
    }

    // min height
    var setHeroMinHeight = function(){
      var min_height = $('.content .inner .container', $hero).outerHeight(true);
      $hero.css('min-height', min_height);
    };

    setHeroMinHeight();

    $window.on('resize', function(){
      setHeroMinHeight();
    });

    if($('.logo img', $hero).length > 0){
      var image = new Image();
      image.onload = function(){
        setHeroMinHeight();
      }
      image.src = $('.logo img', $hero).attr('src');
    }
  }

  Hero.prototype = _.assignIn({}, Hero.prototype, {
    onDeselect: function(event) {
      if ($slides.data('autoplay')) {
        $slides.slick('slickPlay');
      }
    },
    onBlockSelect: function(event) {
      var $target = $(event.target);
      $slides.slick('slickPause');
      $slides.slick('slickGoTo', $target.data('index'), true);
    },
    onBlockDeselect: function(event) {
      this.onDeselect(event);
    }
  });

  return Hero;
})();

California.FeaturedCollection = (function() {

  function FeaturedCollection(container) {
    $(document).trigger('products_rendered');
  }

  return FeaturedCollection;
})();

California.InstagramFeed = (function() {

  function InstagramFeed(container) {
    var $container = $(container),
        $empty = $('<div class="section no-content">').html("Your Instagram Access Token required to display your Instagram Feed is invalid.<br>Check <a href='http://www.smallvictories.co/themes/instagram-access-token' target='_blank'>this page</a> and edit the access token value in the sidebar."),
        limit = $container.data('limit'),
        token = $container.data('token'),
        url = "https://api.instagram.com/v1/users/self/media/recent?access_token=" + token + "&count=" + limit + "&callback=";

    if (token.length > 0) {
      $.ajax({
        type: "GET",
        dataType: "jsonp",
        url: url,
        success: function(response) {
          if (response.meta.code == 200) {
            for(var i = 0, len = response.data.length; i < len; i++ ){
              var photo = response.data[i];
              $(".instagram-photos", $container)
                .append("<a class='instagram-photo' target='_blank' href='" + photo.link + "'><img src='" + photo.images.standard_resolution.url + "'/></a>");
              $('.js-button-instagram', $container)
                  .attr('href', 'https://www.instagram.com/' + photo.user.username)
                  .attr('target', '_blank');
            }
          } else {
            $(".instagram-photos", $container).append($empty);
            window.console.log(response.meta.error_message);
          }
        }
      });
    }
  }
  return InstagramFeed;
})();

California.Variants = (function() {
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.enableHistoryState = options.enableHistoryState;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;

    var currentOptions = this._getCurrentOptions();
    this.currentVariant = this._getVariantFromOptions(currentOptions);

    $(this.singleOptionSelector).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    _getCurrentOptions: function() {
      return _.map($(this.singleOptionSelector, this.$container), function(select) {
        return $(select).val();
      });
    },

    _getVariantFromOptions: function(selectedValues) {
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(value) {
          return (variant.options.indexOf(value) !== -1);
        });
      });

      return found;
    },

    _onSelectChange: function() {
      var options = this._getCurrentOptions();
      var variant = this._getVariantFromOptions(options);

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    _updateHistoryState: function(variant) {
      if (!history.pushState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    _updateMasterSelect: function(variant) {
      var $originalSelector = $(this.originalSelectorId);

      if (!variant) {
        return;
      }

      $originalSelector.find('[selected]').removeAttr('selected');
      $originalSelector.find('[value=' + variant.id + ']').attr('selected', 'selected');
    }
  });

  return Variants;
})();
California.Product = (function() {

  function Product(container) {
    var $container = this.$container = $(container),
        sectionId = $container.attr('data-section-id'),
        self = this;

    this.$item = $('.item', $container);
    this.$info = $('.info', $container);
    this.$images = $('.images', $container);
    this.$image = $('.images .image', $container);
    this.$window = $(window);
    this.$footer = $('.footer');
    this.index = 0;

    this.selectors = {
      originalSelectorId: '#productSelect-' + sectionId,
      addToCart: '#addToCart-' + sectionId,
      productPrice: '#productPrice-' + sectionId,
      comparePrice: '#comparePrice-' + sectionId,
      productStock: '#productStock-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId
    };

    this.settings = {
      sectionId: sectionId,
      enableHistoryState: $container.data('enable-history-state') || true,
      namespace: '.product-' + sectionId
    };

    // Stop parsing if we don't have the product json script tag
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($('#ProductJson-' + sectionId).html());

    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {
      this.initVariants();
      this.initGallery();
      this.initImageZoom();
    },
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        product: this.productSingleObject,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId
      };

      this.variants = new California.Variants(options);
      this.$container.on('variantChange' + this.settings.namespace, this.updateAddToCartButton.bind(this));
      this.$container.on('variantPriceChange' + this.settings.namespace, this.updatePrices.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this.updateImages.bind(this));
    },
    updateAddToCartButton: function(event){
      var variant = event.variant;

      var cache = {
        $stock: $(this.selectors.productStock),
        $addToCart: $(this.selectors.addToCart)
      };

      if (variant) {
        // Select a valid variant if available
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
          cache.$addToCart.removeClass('disabled').prop('disabled', false).val(cache.$addToCart.data('value'));
        } else {
          // Variant is sold out, disable the submit button
          cache.$addToCart.val(California.strings.sold_out).addClass('disabled').prop('disabled', true);
        }

        // Update inventory tracking if it's setup
        if (variant.inventory_management == 'shopify') {
          cache.$stock.show().find('span.units').html(variant.inventory_quantity);
        } else {
          cache.$stock.hide();
        }
      } else {
        cache.$addToCart.val(California.strings.unavailable).addClass('disabled').prop('disabled', true);
      }
    },
    updatePrices: function(event){
      var variant = event.variant;

      if (variant) {
        $(this.selectors.productPrice).html(California.Currency.formatMoney(variant.price, California.strings.money_format));

        // Update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice)
            .html(California.Currency.formatMoney(variant.compare_at_price, California.strings.money_format))
            .show();
        } else {
          $(this.selectors.comparePrice).hide();
        }
      } else {
        $(this.selectors.comparePrice).hide();
      }
      California.onPriceAdded();
    },
    updateImages: function(event){
      var variant = event.variant;

      if (variant && variant.featured_image) {
        var $image = $('#image_' + variant.featured_image.id),
            padding = 15,
            header_height = 200,
            offset = $image.offset().top - padding;
        
        if (offset < header_height){
          offset = 0;
        }

        if (this.$window.width() <= 720){
          this.showWithIndex($image.index());
        } else if (this.imagesAreHigherThanInfo() && this.infoFitsOnScreen()) {
          $('body,html').animate({
            scrollTop: offset
          }, {
            duration: 600
          });
        } else {
          this.$images.prepend($image);
        }

        // Update index in case it goes to the mobile version
        this.index = $image.index();
      }
    },
    initGallery: function() {
      var self = this;

      enquire.register("screen and (max-width:720px)", {
        match : function() {
          $(document)
            .on('click.image', '.product .images .image', function(e){
              e.preventDefault();
              self.show(+1);
            })
            .on('click.next-image', '[data-action=show-next-image]', function(e){
              e.preventDefault();
              self.show(+1);
            })
            .on('click.prev-image', '[data-action=show-prev-image]', function(e){
              e.preventDefault();
              self.show(-1);
            });
        },      
        unmatch: function() {
          $(document)
            .off('click.image')
            .off('click.next-image')
            .off('click.prev-image');
        }
      });

      if (this.$window.width() > 720){
        this.fixScrollOn();
      } else {
        this.showWithIndex(this.index);
      }

      enquire.register("screen and (max-width:720px)", {
        unmatch: function() {
          self.fixScrollOn();
          self.$image.show();
        }
      });

      enquire.register("screen and (min-width:721px)", {
        unmatch: function() {
          self.showWithIndex(self.index);
          self.fixScrollOff();
        }
      });
    },
    imagesAreHigherThanInfo: function(){
      return this.$images.height() > this.$info.height();
    },
    infoFitsOnScreen: function(){
      return this.$info.height() < this.$window.height() - this.$footer.height();
    },
    show: function(inc){
      this.showWithIndex((this.index + inc) % this.$image.length);
    },
    showWithIndex: function(value){
      window.$images = this.$image;
      this.index = value;
      this.$image.hide().eq(this.index).show();
    },
    fixScrollOn: function(){
      var edge = this.$info.offset().top,
          self = this;
      this.$window.on('scroll.checker resize.checker touchmove.checker', function() {
        var scrolled = self.$window.scrollTop(),
            scroll_has_gone_over_the_edge = scrolled > edge,
            fix = scroll_has_gone_over_the_edge && self.imagesAreHigherThanInfo() && self.infoFitsOnScreen(),
            left = self.$item.offset().left + self.$images.width() + parseInt(self.$images.css('margin-right'));

        self.$info.toggleClass('fixed', fix);
        self.$info.css('left', left);
      });
    }, 
    fixScrollOff: function(){
      this.$window.off('scroll.checker resize.checker touchmove.checker');
    },
    initImageZoom: function() {
      $('[data-mfp-src]', this.$container).magnificPopup({
        type: 'image',
        mainClass: 'mfp-fade',
        closeOnBgClick: true,
        closeBtnInside: false,
        closeOnContentClick: true,
        tClose: California.strings.zoom_close,
        removalDelay: 500,
        disableOn: 720,
        gallery: {
          enabled: true,
          navigateByImgClick: false,
          arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
          tPrev: California.strings.zoom_previous,
          tNext: California.strings.zoom_next
        }
      });
    }
  });

  return Product;
})();

California.SideNav = (function() {

  function SideNav(container) {
  }

  SideNav.prototype = _.assignIn({}, SideNav.prototype, {
    onSelect: function(event) {
      if(!$('body').hasClass('browsing')) {
        $('[data-action=toggle-browse]').first().click();
      }
    },
    onDeselect: function(event) {
      if($('body').hasClass('browsing')) {
        $('[data-action=toggle-browse]').first().click();
      }
    }
  });

  return SideNav;
})();

$(document).ready(function() {
  California.initIE();
  California.initEasings();
  California.initPlaceholders();
  California.init();
});

California.init = function(){
  California.initPageConfig();
  California.initListeners();
  California.initSections();
  California.initLoginPage();
  California.initAddressesPage();
  California.initSearchPage();
  California.initFooter();
  $(document).trigger('products_rendered');
};

California.initPageConfig = function(){
  if (window.is_ie) {
    $("html").addClass("ie");
  }
};

California.initListeners = function(){

  window.previousLists = [];


  $(document)

    .on('click', '[data-action=toggle-search]', function(e){
      var $body = $('body');
      if($body.hasClass('browsing')){
        $('[data-action=toggle-browse]').first().click();
      };
      $body.toggleClass('searching').find('i').toggleClass('fa-times fa-search');
      $('[data-action=toggle-search]').toggleClass('active');
      if($body.hasClass('searching')){
        $('.search-bar input.query').focus();
      } else {
        $('.search-bar input.query').blur();
      }
      e.preventDefault();
    })

    .on('click', '[data-action=go-back]', function(e){
      window.history.back();
      e.preventDefault();
    })

    .on('click', '[data-action=toggle-browse]', function(e){
      if ($('body').hasClass('browsing')) {
        California.closeSideNav();
      } else {
        California.openSideNav();
      }
      e.preventDefault();
    })

    .on('click', '.browsing', function(e) {
      e.stopPropagation();
      var $target = $(e.target);
      if (!$target.closest('.side-nav a').length && !$target.closest('[data-action=toggle-browse]').length) {
        California.closeSideNav();
        e.preventDefault();
      }
    })

    .on('change', '.tickets .number select', function() {
      return $(this).parent('form').submit();
    })
    
    .on('click', '[data-action=process][data-message]', function(e) {
      var $this = $(this),
          $window = $(window);

      $('<a>').insertAfter($this).attr('class', $this.attr('class') + ' processing').html($this.attr('data-message')).prepend($('<i class="fa fa-cog fa-spin">'));
      $this.hide();
    })

    .on('click', '[data-action=scroll]', function(e) {
      e.preventDefault();
      $('body,html').animate({
        scrollTop: $('.hero').height() + (window.is_iphone ? 30 : 0)
      }, {
        duration: 600,
        easing: "easeInOutQuad"
      });
    })

    .on('click', '[data-action=load-more-collections][data-message]', function(e){
      e.preventDefault();
      
      var $this = $(this),
          $a = $('<a>').attr('class', $this.attr('class') + ' processing').html($this.attr('data-message')).prepend($('<i class="fa fa-cog fa-spin">'));

      $a.insertAfter($this)
      $this.hide();

      $.ajax({
        type: 'GET',
        dataType: 'html',
        url: $this.attr('href'),
        success: function(data) {
          var $current_collections  = $('.collections .collection'),
              $new_collections = $(data).find('.collections .collection'),
              $new_pagination_button = $(data).find('[data-action=load-more-collections]');

          $new_collections.insertAfter($current_collections.last()).fadeTo(0,0).fadeTo(300, 1);
          $a.remove();
          if ($new_pagination_button.length){
            $this.attr('href', $new_pagination_button.attr('href')).show();
          } else {
            $this.remove();
          }
          $(document).trigger('products_rendered');
        }
      });
    })

    .on('click', '[data-action=load-more-products][data-message]', function(e){
      e.preventDefault();
      
      var $this = $(this),
          $a = $('<a>').attr('class', $this.attr('class') + ' processing').html($this.attr('data-message')).prepend($('<i class="fa fa-cog fa-spin">'));

      $a.insertAfter($this)
      $this.hide();

      $.ajax({
        type: 'GET',
        dataType: 'html',
        url: $this.attr('href'),
        success: function(data) {
          var $current_products  = $('.products .product'),
              $new_products = $(data).find('.products .product'),
              $new_pagination_button = $(data).find('[data-action=load-more-products]');

          $new_products.insertAfter($current_products.last()).fadeTo(0,0).fadeTo(300, 1);
          $a.remove();
          if ($new_pagination_button.length){
            $this.attr('href', $new_pagination_button.attr('href')).show();
          } else {
            $this.remove();
          }
          $(document).trigger('products_rendered');
        }
      });
    })

    .on('click', '[data-action=load-more-articles][data-message]', function(e){
      e.preventDefault();
      
      var $this = $(this),
          $a = $('<a>').attr('class', $this.attr('class') + ' processing').html($this.attr('data-message')).prepend($('<i class="fa fa-cog fa-spin">'));

      $a.insertAfter($this)
      $this.hide();

      $.ajax({
        type: 'GET',
        dataType: "html",
        url: $this.attr('href'),
        success: function(data) {
          var $current_articles  = $('.blog .post'),
              $new_articles = $(data).find('.blog .post'),
              $new_pagination_button = $(data).find('[data-action=load-more-articles]');

          $new_articles.insertAfter($current_articles.last()).fadeTo(0,0).fadeTo(300, 1);
          $a.remove();
          if ($new_pagination_button.length){
            $this.attr('href', $new_pagination_button.attr('href')).show();
          } else {
            $this.remove();
          }
        }
      });
    })

    .on('change', '[data-action=update]', function(){
      $('input.update').click();
    })

    .on('change', 'select[data-action=filter]', function(){
      window.location.href = $(this).val();
    })

    .on('keydown', '.field_with_errors > input', function() {
      return $(this).parent().removeClass('field_with_errors');
    })

    .on('click', '[data-action=toggle-recover-password]', function(){
      $('#recover_password').toggle();
      $('#login').toggle();

      if($('#recover_password').is(':visible')){
        $('#recover_password input#recover-email').focus();
      } else {
        $('#login input#customer_email').focus();
      }
    })

    .on('keydown', 'body', function(e){
      var $body = $('body');
      if($body.hasClass('searching') && e.which === 27){
        $('[data-action=toggle-search]').first().click();
      }
      if($body.hasClass('browsing') && e.which === 27){
        $('[data-action=toggle-browse]').first().click();
      }
      $('[data-action=keydown][data-key][href]').each(function(){
        if(!$.magnificPopup.instance.isOpen){
          if(e.which === parseInt($(this).attr('data-key'))){
            $(this).addClass("hover");
            window.location.href = $(this).attr('href');
          }
        }
      });
    })

    .on('products_rendered', function(){
      $('.products .product img:not(.loaded)').each(function(){
        var image = new Image(),
            $image = $(this),
            $product = $image.parents('.product'),
            $frame = $('.frame', $product),
            $line = $('.line', $product);

        $frame.hide();
        $line.hide();

        image.onload = function(){
          var width = image.width,
              height = image.height,
              angle = -Math.round(Math.atan2(height, width) * 57.2957795, 2);

          $line
            .css('transform', 'rotate(' + angle + 'deg)')
            .css('-ms-transform', 'rotate(' + angle + 'deg)')
            .css('-moz-transform', 'rotate(' + angle + 'deg)')
            .css('-webkit-transform', 'rotate(' + angle + 'deg)')
            .css('-o-transform', 'rotate(' + angle + 'deg)')
            .show();

          $image
            .addClass('loaded');

          $frame.show();

        };
        image.src = $image.attr('src');
      });
      California.onPriceAdded();
    })

    .on('click', '[data-action=link-to-child-list][data-handle]', function(e){
      var handle = $(this).attr('data-handle'),
          $previousList = $('[data-action=link-to-child-list][data-handle=' + handle + ']').parents('ul'),
          $lists = $('.nav ul'),
          $list = $('.nav .' + handle);


      if($list.length > 0){
        window.previousLists.push($previousList);
        $lists.hide();
        $list.show();
        e.preventDefault();
      }
    })

    .on('click', '[data-action=back-to-previous-list]', function(e){
      California.showPreviousList();
      e.preventDefault();
    })

    .on('click', '[data-action=remove]', function(e){
      $(this).addClass('click-disabled');
    })
    .on('click', '.click-disabled', function(e){
      e.preventDefault();
    })
    .on('click', '[data-action=show-landing]', function(e){
      e.preventDefault();
      $('.landing').fadeIn();
      $('.login').hide();
      $('[data-action=show-login]').removeClass('hide');
      $('[data-action=show-landing]').addClass('hide');
    })
    .on('click', '[data-action=show-login]', function(e){
      e.preventDefault();
      $('.landing').hide();
      $('.login').fadeIn();
      if(!window.is_touch_device){
        $('.login input.email').focus();
      }
      $('[data-action=show-login]').addClass('hide');
      $('[data-action=show-landing]').removeClass('hide');
    });

    if(window.show_password_login){
      $('[data-action=show-login]').first().trigger('click');
    }

};

California.openSideNav = function() {
  var $body = $('body');
  if($body.hasClass('searching')){
    $('[data-action=toggle-search]').first().click();
  };
  $body.addClass('browsing');
  $('[data-action=toggle-browse]').addClass('active')
    .find('i').addClass('fa-times').removeClass('fa-bars');
  California.showMainList();
};

California.closeSideNav = function() {
  $('body').removeClass('browsing');
  $('[data-action=toggle-browse]').removeClass('active')
    .find('i').removeClass('fa-times').addClass('fa-bars');
  California.showMainList();
};

California.showMainList = function(){
  window.previousLists = [];
  $('.nav ul').hide();
  $('.nav .main').show();
};

California.showPreviousList = function(){
  var $previous = window.previousLists.pop() || $('.nav .main'),
      $lists = $('.nav ul');

  $lists.hide();
  $previous.show();
};

California.initSections = function(){
  var sections = new California.Sections();
  sections.register('hero', California.Hero);
  sections.register('featured-collection', California.FeaturedCollection);
  sections.register('instagram-feed', California.InstagramFeed);
  sections.register('product', California.Product);
  sections.register('side-nav', California.SideNav);
};

California.initLoginPage = function(){
  // direct access to recover page: account/login#recover
  if (window.location.hash == '#recover'){ 
    $('[data-action=toggle-recover-password]').first().click();
  }
};

California.initAddressesPage = function(){
  var $body = $('body');

  if ($body.hasClass('template-customers-addresses') && window.customer_addresses){
    // Initialize observers on address selectors
    new Shopify.CountryProvinceSelector('address_country_new', 'address_province_new', {
      hideElement: 'address_province_container_new'
    });

    // Setup province selector on each customer address
    for(var i in window.customer_addresses){
      var id = window.customer_addresses[i];
      new Shopify.CountryProvinceSelector('address_country_' + id, 'address_province_' + id, {
        hideElement: 'address_province_container_' + id
      });
    }

    // Contents of customer_area.js (global asset)
    Shopify.CustomerAddress = {
      toggleForm: function(id) {
        var $form = $('#edit_address_' + id),
            $button = $('#view_address_' + id);
        
        $form.toggle();
        $button.toggle();

        if ($form.is(':visible')){
          $('input:not([type=hidden])', $form).first().focus()
          $('body,html').animate({ scrollTop: $form.offset().top}, { duration: 600 });
        }

        return false;
      },

      toggleNewForm: function() {
        var $form = $('#add_address'),
            $button = $('#add_new_address_button');

        $form.toggle();
        $button.toggle();

        if ($form.is(':visible')){
          $('input:not([type=hidden])', $form).first().focus()
          $('body,html').animate({ scrollTop: $form.offset().top}, { duration: 600 });
        }
        return false;
      },

      destroy: function(id, confirm_msg) {
        if (confirm(confirm_msg || "Are you sure you wish to delete this address?")) {
          Shopify.postLink('/account/addresses/'+id, {'parameters': {'_method': 'delete'}});
        }
      }
    }
  }
};

California.initSearchPage = function(){
  var $body = $('body');

  if ($body.hasClass('template-search')){
    $(document)    
      .on('submit', 'form.search-bar', function(e){
        var $form = $(this);
        $.ajax({
           type: 'POST',
           dataType: 'html',
           url: $form.attr('action'),
           data: $form.serialize(),
           success: function(data){
            $('.main-content').replaceWith($(data).find('.main-content'));
            $(document).trigger('products_rendered');
           }
         });
        e.preventDefault();
      });
  }
};

California.initFooter = function() {
  $('.footer [href="https://www.shopify.com"]').attr('href', "https://www.shopify.com?ref=guille-lopez");
};

California.initIE = function(){
  // add ie class
  if (window.is_ie) {
    $("html").addClass("ie");
  }
};

California.initEasings = function(){
  var baseEasings = {};

  $.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
    baseEasings[ name ] = function( p ) {
      return Math.pow( p, i + 2 );
    };
  });

  $.extend( baseEasings, {
    Sine: function( p ) {
      return 1 - Math.cos( p * Math.PI / 2 );
    },
    Circ: function( p ) {
      return 1 - Math.sqrt( 1 - p * p );
    },
    Elastic: function( p ) {
      return p === 0 || p === 1 ? p :
        -Math.pow( 2, 8 * (p - 1) ) * Math.sin( ( (p - 1) * 80 - 7.5 ) * Math.PI / 15 );
    },
    Back: function( p ) {
      return p * p * ( 3 * p - 2 );
    },
    Bounce: function( p ) {
      var pow2,
        bounce = 4;

      while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
      return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
    }
  });

  $.each( baseEasings, function( name, easeIn ) {
    $.easing[ "easeIn" + name ] = easeIn;
    $.easing[ "easeOut" + name ] = function( p ) {
      return 1 - easeIn( 1 - p );
    };
    $.easing[ "easeInOut" + name ] = function( p ) {
      return p < 0.5 ?
        easeIn( p * 2 ) / 2 :
        1 - easeIn( p * -2 + 2 ) / 2;
    };
  });
};

California.initPlaceholders = function(){
  $('input, textarea').placeholder();
};

California.onPriceAdded = function(){
  if(window.Currency){
    Currency.convertAll(shopCurrency, $('[name=currencies]').val());
    onCurrencySet();
  }
}